module.exports = __webpack_public_path__ + "static/media/beach_dock.e642fe0f.jpg";